import { useEffect, useState } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { FaRegPlusSquare } from "react-icons/fa";
import Swal from "sweetalert2";

const Add = ({apiUrl}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [desc, setDesc] = useState('');

  const getGymDetails = async()=>{
    try {
      const response = await fetch(`${apiUrl}/${id}`);
      const result = await response.json()
      if(response.ok){
        setName(result.name);
        setDesc(result.desc);
      }
      else{
        throw new Error(result.message);
      }
    } catch (error) {
      alert(error.message);
    }
  }

  useEffect(()=>{
    getGymDetails();
  }, []);

  const submitHandler = async(e)=> {
    e.preventDefault();

    try {
      const response = await fetch(`${apiUrl}/${id}`, {
        method: 'PUT',
        headers:{
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({name, desc})
      });
      if(response.ok){
        Swal.fire({
          title: 'Gym Saved',
          text: 'Gym details have been saved',
          icon: 'success',
          confirmButtonColor: 'mediumblue',
          confirmButtonText: 'Okay'
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/');
          }
        });
      }else{
        const result = await response.json();
        throw new Error(result.message);
      }
    } catch (error) {
      Swal.fire(
        'Error!',
        error.message,
        'error'
      );
    }
  }

  return (
    <div className='container mt-3'>
      <div className='row'>
        <div className='offset-md-3 col-md-6'>
          <form className='container mt-3' onSubmit={submitHandler}>
            <h1>
              Edit Gym
              <Link to="/" className="btn btn-primary btn-sm mb-3 float-end">
                <FaRegPlusSquare /> Back to Gym List
              </Link>
            </h1>
            <div className='mb-3'>
              <input type="text" placeholder='Gym Name *' className='form-control' value={name} onChange={(e)=> setName(e.target.value)} required />
            </div>
            <div className='mb-3'>
              <input type="text" placeholder='Gym Description *' className='form-control' onChange={(e)=> setDesc(e.target.value)} value={desc} required />
            </div>
            <div className='mb-3'>
              <button type="submit" className='btn btn-success btn-sm'>Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Add